import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function N() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const { locale } = useRouter();
    const [isEnterB, setIsEnterB] = useState(false);
    const productList = [
        {
            name: 'detail.delta_max',
            img: 'delta_max',
        },
        {
            name: 'wave2_name',
            img: 'wave2',
        },
        {
            name: 'detail.delta_2',
            img: locale === 'au' ? 'delta_pro' : 'delta_2',
        },
    ];

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.wave2-detail-N .viewport-wrapper', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-N .viewport-wrapper',
            triggerHook: 1,
            offset: '10%',
            duration: '20%',
        });
        AniContainer.create({
            triggerElement: '.wave2-detail-N .ani-wrapper',
            triggerHook: 0.5,
            offset: '10%',
            duration: 0,
            onEnter: () => setIsEnterB(true),
            onLeave: () => setIsEnterB(false),
        });
    }, []);

    return (
        <div className={`wave2-detail-N ${css.wave2DetailN} ${isEnterB ? 'isEnterB' : ''}`}>
            <div className="viewport-wrapper">
                <div className="text-wrapper">
                    <p className="title">{t('detail.sectionN_title')}</p>
                    <p className="desc">{t('detail.sectionN_desc')}</p>
                </div>
                <div className="ani-wrapper">
                    <div className="img-wrapper">
                        {productList.map((item, i) => (
                            <div className={`product product-${i}`} key={i}>
                                <NextImage
                                    webpSrc={require(`@publicLocal/wave2/detail/${item.img}.webp`)}
                                    src={require(`@publicLocal/wave2/detail/${item.img}.png`)}
                                    alt={t(item.name)}
                                    aria-label={t(item.name)}
                                />
                                <p className="text">{t(item.name)}</p>
                            </div>
                        ))}
                    </div>
                    <div className="bar-list">
                        <div className="bar-wrapper bar-1">
                            <div className="left">
                                <div className="bar">
                                    <div className="process"></div>
                                </div>
                                <p className="text">{t('detail.width_delta_max')}</p>
                            </div>
                            <p className="right">
                                {t.rich('detail.14Hrs', {
                                    unit: (unit: any) => <span className="unit">{unit}</span>,
                                })}
                            </p>
                        </div>
                        <div className="bar-wrapper bar-2">
                            <div className="left">
                                <div className="bar">
                                    <div className="process"></div>
                                </div>
                                <p className="text">{t('detail.width_delta_2')}</p>
                            </div>
                            <p className="right">
                                {t.rich('detail.7Hrs', {
                                    unit: (unit: any) => <span className="unit">{unit}</span>,
                                })}
                            </p>
                        </div>
                        <div className="bar-wrapper bar-3">
                            <div className="left">
                                <div className="bar">
                                    <div className="process"></div>
                                </div>
                                <p className="text">{t('detail.others')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {locale === 'cn' && <p className="memo">{t('detail.secN_memo')}</p>}
            </div>
        </div>
    );
}
